// src/components/About.js
import React, { useState } from "react";
import AmenitiesModal from "../modals/AmenitiesModal";
import CustomDropdown from "../common/CustomDropdown";

const PropertyValuationDetailForm = ({
  activeStep,
  errors,
  formData,
  handleInputChange,
  handleNextStep,
  handleSubmit,
}) => {
  const ownershipOption = [
    { value: "freehold", label: "Freehold" },
    { value: "leasehold", label: "Leasehold" },
    { value: "cooperative_society", label: "Cooperative Society" },
    { value: "power_attorney", label: "Power of attorney" },
  ];

  const interiorOption = [
    { value: "less than 1", label: "Less Than 1 yrs" },
    { value: "1-3", label: "1-3 yrs" },
    { value: "3-5", label: "3-5 yrs" },
    { value: "5-10", label: "5-10 yrs" },
    { value: "+10", label: "+10 yrs" },
  ];

  const transactionType = [
    { value: "new_booking", label: "New Booking" },
    { value: "resale", label: "Resale" },
  ];

  const areaUnitOption = [
    { value: "sq.ft.", label: "sq.ft." },
    { value: "sq.yd.", label: "sq.yd." },
    { value: "sq.mt.", label: "sq.mt." },
  ];

  const zoneTypeOption = [
    { value: "industrial", label: "Industrial" },
    { value: "commercial", label: "Commercial" },
    { value: "residential", label: "Residential" },
    { value: "economic", label: "Special Economic Zone" },
    { value: "open_space", label: "Open Space" },
    { value: "agricultural", label: "Agricultural Zone" },
    { value: "other", label: "Others" },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  switch (activeStep) {
    case 1:
      return (
        <div className="forms">
          <div className="formHeader">
            <span>Add Property Details</span>
            <span className="infoIcon">ⓘ</span>
          </div>
          <div className="formBody">
            <div
              className={`formRow mt-4 ${
                errors.property_age || errors.interiors ? "mb-5" : "mb-3"
              }`}
            >
              {[
                "apartment",
                "villa",
                "independent_floor",
                "independent_house",
                "office",
                "showroom",
                "retailshop",
              ].includes(formData.propertyDetails.property_type) && (
                <>
                  <div className="input-container w-50">
                    <input
                      type="text"
                      id="property_age"
                      placeholder=" "
                      value={formData.propertyDetails.property_age || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "propertyDetails",
                          "property_age",
                          e.target.value
                        )
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                      className="textField"
                    />
                    <label htmlFor="property_age" className="floating-label">
                      Age of Property(in years)
                      <span className="required_field">*</span>
                    </label>
                    {errors.property_age && (
                      <small className="text-danger propag">
                        {errors.property_age}
                      </small>
                    )}
                  </div>
                </>
              )}
              {[
                "apartment",
                "villa",
                "independent_floor",
                "independent_house",
              ].includes(formData.propertyDetails.property_type) && (
                <>
                  <div className=" w-50">
                    <CustomDropdown
                      formData={formData}
                      handleInputChange={handleInputChange}
                      index={"propertyDetails"}
                      field={"interiors"}
                      options={interiorOption}
                      placeholder="Interiors"
                      required={"1"}
                      onSelect={(value) => console.log("interiors:", value)}
                    />
                    {errors.interiors && (
                      <small className="text-danger">{errors.interiors}</small>
                    )}
                  </div>
                </>
              )}
            </div>
            {[
              "apartment",
              "villa",
              "independent_floor",
              "independent_house",
              "office",
              "showroom",
              "retailshop",
              "warehouse",
            ].includes(formData.propertyDetails.property_type) && (
              <>
                <div
                  className={`formRow mt-4 ${
                    errors.buildup_area ? "mb-5" : "mb-3"
                  }`}
                >
                  <div className="input-container w-50">
                    <input
                      type="text"
                      id="buildup_area"
                      placeholder=" "
                      value={formData.propertyDetails.buildup_area || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "propertyDetails",
                          "buildup_area",
                          e.target.value
                        )
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                      className="textField"
                    />
                    <label htmlFor="buildup_area" className="floating-label">
                      BuiltUp Area (Sq. Ft){" "}
                      <span className="required_field">*</span>
                    </label>
                    {errors.buildup_area && (
                      <small className="text-danger">
                        {errors.buildup_area}
                      </small>
                    )}
                  </div>
                </div>
              </>
            )}
            {["plot"].includes(formData.propertyDetails.property_type) && (
              <>
                <div
                  className={`formRow mt-4 ${
                    errors.width_facing_road || errors.plot_area
                      ? "mb-5"
                      : "mb-3"
                  }`}
                >
                  <div className="input-container w-50">
                    <input
                      type="text"
                      id="plot_area"
                      placeholder=" "
                      value={formData.propertyDetails.plot_area || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "propertyDetails",
                          "plot_area",
                          e.target.value
                        )
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                      className="textField"
                    />
                    <label htmlFor="plot_area" className="floating-label">
                      Plot Area<span className="required_field">*</span>
                    </label>
                    {errors.plot_area && (
                      <small className="text-danger">{errors.plot_area}</small>
                    )}
                  </div>
                  <div className="input-container w-50">
                    <input
                      type="text"
                      id="width_facing_road"
                      placeholder=" "
                      className="textField"
                      value={formData.propertyDetails.width_facing_road || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "propertyDetails",
                          "width_facing_road",
                          e.target.value
                        )
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                    />
                    <label
                      htmlFor="width_facing_road"
                      className="floating-label"
                    >
                      Width of Facing Road{" "}
                      <span className="required_field">*</span>
                    </label>
                    {errors.width_facing_road && (
                      <small className="text-danger">
                        {errors.width_facing_road}
                      </small>
                    )}
                  </div>
                </div>
                <div
                  className={`formRow mt-4 ${
                    errors.length || errors.width ? "mb-5" : "mb-3"
                  }`}
                >
                  <div className="input-container w-50">
                    <input
                      type="text"
                      id="width"
                      placeholder=" "
                      value={formData.propertyDetails.width || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "propertyDetails",
                          "width",
                          e.target.value
                        )
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                      className="textField"
                    />
                    <label htmlFor="width" className="floating-label">
                      Plot Width <span className="required_field">*</span>
                    </label>
                    {errors.width && (
                      <small className="text-danger">{errors.width}</small>
                    )}
                  </div>
                  <div className="input-container w-50">
                    <input
                      type="text"
                      id="length"
                      placeholder=" "
                      value={formData.propertyDetails.length || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "propertyDetails",
                          "length",
                          e.target.value
                        )
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                      className="textField"
                    />
                    <label htmlFor="length" className="floating-label">
                      Plot Length <span className="required_field">*</span>
                    </label>
                    {errors.length && (
                      <small className="text-danger">{errors.length}</small>
                    )}
                  </div>
                </div>
              </>
            )}
            <div
              className={`formRow mt-4 ${
                errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
              }`}
            >
              {["plot", "warehouse"].includes(
                formData.propertyDetails.property_type
              ) &&
                ["commercial"].includes(
                  formData.propertyDetails.property_category
                ) && (
                  <>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                  </>
                )}
              {["warehouse"].includes(formData.propertyDetails.property_type) &&
                ["commercial"].includes(
                  formData.propertyDetails.property_category
                ) && (
                  <>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </>
                )}
            </div>
            {["agricultural_land"].includes(
              formData.propertyDetails.property_type
            ) && (
              <>
                <div
                  className={`formRow mt-4 ${
                    errors.plot_area || errors.area_unit ? "mb-5" : "mb-3"
                  }`}
                >
                  <div className="input-container w-50">
                    <input
                      type="text"
                      id="plot_area"
                      placeholder=" "
                      value={formData.propertyDetails.plot_area || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "propertyDetails",
                          "plot_area",
                          e.target.value
                        )
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                      className="textField"
                    />
                    <label htmlFor="plot_area" className="floating-label">
                      Plot Area<span className="required_field">*</span>
                    </label>
                    {errors.plot_area && (
                      <small className="text-danger">{errors.plot_area}</small>
                    )}
                  </div>
                  <div className="w-50">
                    <CustomDropdown
                      formData={formData}
                      handleInputChange={handleInputChange}
                      index={"propertyDetails"}
                      field={"area_unit"}
                      options={areaUnitOption}
                      placeholder="Select Area Unit"
                      required={"1"}
                      onSelect={(value) => console.log("area unit:", value)}
                    />
                    {errors.area_unit && (
                      <small className="text-danger">{errors.area_unit}</small>
                    )}
                  </div>
                </div>
                <div
                  className={`formRow mt-4 ${
                    errors.length || errors.width ? "mb-5" : "mb-3"
                  }`}
                >
                  <div className="input-container w-50">
                    <input
                      type="text"
                      id="width"
                      placeholder=" "
                      value={formData.propertyDetails.width || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "propertyDetails",
                          "width",
                          e.target.value
                        )
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                      className="textField"
                    />
                    <label htmlFor="width" className="floating-label">
                      Land Width <span className="required_field">*</span>
                    </label>
                    {errors.width && (
                      <small className="text-danger">{errors.width}</small>
                    )}
                  </div>
                  <div className="input-container w-50">
                    <input
                      type="text"
                      id="length"
                      placeholder=" "
                      value={formData.propertyDetails.length || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "propertyDetails",
                          "length",
                          e.target.value
                        )
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                      className="textField"
                    />
                    <label htmlFor="length" className="floating-label">
                      Land Length <span className="required_field">*</span>
                    </label>
                    {errors.length && (
                      <small className="text-danger">{errors.length}</small>
                    )}
                  </div>
                </div>
                <div
                  className={`formRow mt-4 ${
                    errors.width_facing_road ? "mb-5" : "mb-3"
                  }`}
                >
                  <div className="input-container w-50">
                    <input
                      type="text"
                      id="width_facing_road"
                      placeholder=" "
                      className="textField"
                      value={formData.propertyDetails.width_facing_road || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "propertyDetails",
                          "width_facing_road",
                          e.target.value
                        )
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                    />
                    <label
                      htmlFor="width_facing_road"
                      className="floating-label"
                    >
                      Width of Facing Road{" "}
                      <span className="required_field">*</span>
                    </label>
                    {errors.width_facing_road && (
                      <small className="text-danger">
                        {errors.width_facing_road}
                      </small>
                    )}
                  </div>
                </div>
              </>
            )}
            {[
              "apartment",
              "villa",
              "independent_floor",
              "independent_house",
              "plot",
            ].includes(formData.propertyDetails.property_type) &&
              ["residential"].includes(
                formData.propertyDetails.property_category
              ) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.transaction_type ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"transaction_type"}
                        options={transactionType}
                        placeholder="Transaction Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("transaction type:", value)
                        }
                      />
                      {errors.transaction_type && (
                        <small className="text-danger">
                          {errors.transaction_type}
                        </small>
                      )}
                    </div>
                  </div>
                </>
              )}
            {["office"].includes(formData.propertyDetails.property_type) && (
              <>
                <div
                  className={`formRow mt-4 ${
                    errors.number_seat || errors.number_cabin ? "mb-5" : "mb-3"
                  }`}
                >
                  <div className="input-container w-50">
                    <input
                      type="text"
                      id="number_seat"
                      placeholder=" "
                      value={formData.propertyDetails.number_seat || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "propertyDetails",
                          "number_seat",
                          e.target.value
                        )
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                      className="textField"
                    />
                    <label htmlFor="number_seat" className="floating-label">
                      Number of Seat
                    </label>
                    {errors.number_seat && (
                      <small className="text-danger">
                        {errors.number_seat}
                      </small>
                    )}
                  </div>
                  <div className="input-container w-50">
                    <input
                      type="text"
                      id="number_cabin"
                      placeholder=" "
                      value={formData.propertyDetails.number_cabin || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "propertyDetails",
                          "number_cabin",
                          e.target.value
                        )
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                      className="textField"
                    />
                    <label htmlFor="number_cabin" className="floating-label">
                      Number of Cabins
                    </label>
                    {errors.number_cabin && (
                      <small className="text-danger">
                        {errors.number_cabin}
                      </small>
                    )}
                  </div>
                </div>
                <div
                  className={`formRow mt-4 ${
                    errors.number_meeting || errors.conference_room
                      ? "mb-5"
                      : "mb-3"
                  }`}
                >
                  <div className="input-container d-grid w-50">
                    <input
                      type="text"
                      id="number_meeting"
                      placeholder=" "
                      value={formData.propertyDetails.number_meeting || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "propertyDetails",
                          "number_meeting",
                          e.target.value
                        )
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                      className="textField"
                    />
                    <label htmlFor="number_meeting" className="floating-label">
                      Number of Meeting Room
                    </label>
                    {errors.number_meeting && (
                      <small className="text-danger">
                        {errors.number_meeting}
                      </small>
                    )}
                  </div>
                  <div className="input-container d-grid w-50">
                    <input
                      type="text"
                      id="conference_room"
                      placeholder=" "
                      value={formData.propertyDetails.conference_room || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "propertyDetails",
                          "conference_room",
                          e.target.value
                        )
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                      className="textField"
                    />
                    <label htmlFor="conference_room" className="floating-label">
                      Conference Room
                    </label>
                    {errors.conference_room && (
                      <small className="text-danger">
                        {errors.conference_room}
                      </small>
                    )}
                  </div>
                </div>
              </>
            )}
            {["showroom", "retailshop"].includes(
              formData.propertyDetails.property_type
            ) && (
              <>
                <div
                  className={`formRow mt-4 ${
                    errors.entrance_width || errors.ceiling_height
                      ? "mb-5"
                      : "mb-3"
                  }`}
                >
                  <div className="input-container d-grid w-50">
                    <input
                      type="number"
                      id="entrance_width"
                      placeholder=" "
                      className="textField"
                      value={formData.propertyDetails.entrance_width || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "propertyDetails",
                          "entrance_width",
                          e.target.value
                        )
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                    />
                    <label htmlFor="entrance_width" className="floating-label">
                      Entrance width in feet
                    </label>
                    {errors.entrance_width && (
                      <small className="text-danger">
                        {errors.entrance_width}
                      </small>
                    )}
                  </div>
                  <div className="input-container d-grid w-50">
                    <input
                      type="number"
                      id="ceiling_height"
                      placeholder=" "
                      className="textField"
                      value={formData.propertyDetails.ceiling_height || ""}
                      onChange={(e) =>
                        handleInputChange(
                          "propertyDetails",
                          "ceiling_height",
                          e.target.value
                        )
                      }
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                    />
                    <label htmlFor="ceiling_height" className="floating-label">
                      Ceiling height in feet
                    </label>
                    {errors.ceiling_height && (
                      <small className="text-danger">
                        {errors.ceiling_height}
                      </small>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="formFooter">
            <div className="rectangle_323" onClick={handleNextStep}>
              <button className="ribbonText">Next</button>
            </div>
          </div>

          {isModalOpen && (
            <AmenitiesModal
              closeModal={closeModal}
              handleInputChange={handleInputChange}
              formData={formData}
            />
          )}
        </div>
      );
    case 2:
      return (
        <div className="property-right-box1">
          <div className="rightBox-title">
            <p className="verify-title">Verify Your Property</p>
            <div className="imgBox">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.375 3.875V4.6675C11.7487 4.88375 12 5.2875 12 5.75C12 6.44 11.44 7 10.75 7C10.06 7 9.5 6.44 9.5 5.75C9.5 5.2875 9.75125 4.88375 10.125 4.6675V4.1875C10.125 3.67 9.705 3.25 9.1875 3.25C8.67 3.25 8.25 3.67 8.25 4.1875V9.5V9.50812C8.24563 10.8844 7.12687 12 5.75 12C4.37 12 3.25 10.88 3.25 9.5V9.39313C2.52188 9.13563 2 8.44063 2 7.625C2 6.59 2.84 5.75 3.875 5.75C4.91 5.75 5.75 6.59 5.75 7.625C5.75 8.44063 5.22813 9.13563 4.5 9.39313V9.50375C4.5 9.5675 4.505 9.63125 4.515 9.69438C4.53063 9.79437 4.55875 9.89313 4.59812 9.98625C4.65875 10.13 4.74687 10.2619 4.85562 10.3731C4.96 10.48 5.08313 10.5681 5.21875 10.6313C5.335 10.6863 5.45937 10.7231 5.58687 10.7394C5.72375 10.7575 5.86312 10.7525 5.99812 10.7256C6.11438 10.7019 6.2275 10.6619 6.3325 10.6063C6.45625 10.5406 6.56938 10.4544 6.665 10.3513C6.75938 10.25 6.83625 10.1337 6.8925 10.0075C6.93625 9.90875 6.9675 9.80438 6.98438 9.69813C6.995 9.6325 7 9.56625 7 9.5V4.1875C7 2.98 7.98 2 9.1875 2C10.2887 2 11.2006 2.81562 11.3525 3.875H11.375ZM3.875 7C3.53 7 3.25 7.28 3.25 7.625C3.25 7.97 3.53 8.25 3.875 8.25C4.22 8.25 4.5 7.97 4.5 7.625C4.5 7.28 4.22 7 3.875 7Z"
                  fill="#1B4E9B"
                />
              </svg>
              <p>Procedure</p>
            </div>
          </div>
          <div className="formBody2">
            <p className="verify-description">
              We will visit the property to verify it. Schedule the date and
              we’ll get back to you first on call then on location. Please be on
              location at the scheduled date and time.
            </p>
            <div className="d-flex dttim justify-content-between">
              <div className="d-flex w-100">
                <div className=" w-100">
                  <input
                    type="date"
                    id="reminder_date"
                    placeholder="Date"
                    value={formData.propertyDetails.reminder_date || ""}
                    min={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      handleInputChange(
                        "propertyDetails",
                        "reminder_date",
                        e.target.value
                      )
                    }
                    className="verify-input"
                    style={{ width: "90%" }}
                  />
                  {errors.reminder_date && (
                    <small className="text-danger">
                      {errors.reminder_date}
                    </small>
                  )}
                </div>
                <div className=" w-100">
                  <input
                    type="time"
                    id="reminder_time"
                    placeholder=" "
                    value={formData.propertyDetails.reminder_time || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "propertyDetails",
                        "reminder_time",
                        e.target.value
                      )
                    }
                    className="verify-input"
                    style={{ width: "90%" }}
                  />

                  {errors.reminder_time && (
                    <small className="text-danger">
                      {errors.reminder_time}
                    </small>
                  )}
                </div>
              </div>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="ribbon1">
                <button className="ribbonText">Submit</button>
              </div>
            </form>
          </div>
        </div>
      );
  }
};

export default PropertyValuationDetailForm;
